import FlexTypographyArray from "../../../../components/LyfeTable/FlexTypographyArray";

export default function ProductColumn(props: { product: string }) {
	return <FlexTypographyArray rowData={props} fieldAssessor="product" />;
}
